export const VIEWS = {
    BADGES: 'BADGES',
    LEADERBOARD: 'LEADERBOARD',
    COMMUNITY: 'COMMUNITY',
    VICTORIES: 'VICTORIES',
};